import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    restreams: [],
    fetchingRestreams: false,
    creatingRestream: false,
    updatingRestream: false,
    removingRestream: false,
    resultInfo: {},
    currentPage: 1,
    wizardActiveTab: null,
    gjBlob: null,
  },
  getters: {
    currentPage: state => state.currentPage,
  },
  mutations: {
    SET_RESTREAMS(state, res) {
      state.restreams = res.result
      state.resultInfo = res.resultInfo
    },
    SET_FETCHING_RESTREAMS(state, value) {
      state.fetchingRestreams = value
    },
    SET_CREATING_RESTREAM(state, value) {
      state.creatingRestream = value
    },
    SET_UPDATING_RESTREAM(state, value) {
      state.updatingRestream = value
    },
    SET_REMOVING_RESTREAM(state, value) {
      state.removingRestream = value
    },
    SET_CURRENT_PAGE(state, value) {
      state.currentPage = value
    },
  },
  actions: {
    fetchRestreams({ commit }, liveHubName) {
      commit('SET_FETCHING_RESTREAMS', true)
      return new Promise((resolve, reject) => {
        api('encoderV2')
          .get(`projects/${getProjectId()}/Restreams?id=${liveHubName}`)
          .then(response => {
            commit('SET_RESTREAMS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_RESTREAMS', false)
          })
      })
    },
    createRestream({ commit }, query) {
      commit('SET_CREATING_RESTREAM', true)
      return new Promise((resolve, reject) => {
        api('encoderV2')
          .post(`projects/${getProjectId()}/Restreams?id=${query.liveHubName}`, query.restream)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_CREATING_RESTREAM', false)
          })
      })
    },
    removeRestream({ commit }, query) {
      commit('SET_REMOVING_RESTREAM', true)
      return new Promise((resolve, reject) => {
        api('encoderV2')
          .put(`/projects/${getProjectId()}/Restreams/?id=${query.liveHubName}&serverURL=${query.serverURL}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_REMOVING_RESTREAM', false) })
      })
    },
    toggleRestream({ commit }, query) {
      commit('SET_UPDATING_RESTREAM', true)
      return new Promise((resolve, reject) => {
        api('encoderV2')
          .put(`/projects/${getProjectId()}/Restreams/toggle?id=${query.liveHubName}&serverURL=${query.serverURL}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_UPDATING_RESTREAM', false) })
      })
    },
  },
}
